export default "__VITE_ASSET__DeQQKwh3__"